export default {
  header: {
    nav: {
      home: "Accueil",
      solutions: "Solutions",
      pricing: "Tarifs",
      demo: "Démo",
      blog: "Blog",
      login: "CONNEXION",
      signup: "INSCRIPTION"
    }
  },
  hero: {
    title: "Conception et déploiement multicloud simplifiés",
    subtitle: "Modélisez, estimez et déployez vos architectures sur Azure, AWS et GCP avec une interface intuitive."
  },
  features: {
    visualDesign: {
      title: "Conception Multicloud Visuelle",
      description: "Créez, modélisez et visualisez des architectures cloud sur Azure, AWS, GCP ou hybride avec une interface drag-and-drop intuitive."
    },
    costEstimation: {
      title: "Estimation & Optimisation des Coûts",
      description: "Estimez les coûts mensuels en temps réel et recevez des recommandations automatiques pour optimiser vos dépenses cloud."
    },
    autoDeployment: {
      title: "Déploiement Automatisé avec Azure DevOps",
      description: "Générez automatiquement des scripts Terraform, PowerShell ou YAML et déployez via CI/CD en un clic."
    },
    multiClient: {
      title: "Gestion Multi-Clients Sécurisée",
      description: "Administrez plusieurs organisations dans des espaces sécurisés, avec gestion des rôles et permissions."
    },
    dashboard: {
      title: "Tableaux de Bord & Suivi Temps Réel",
      description: "Analysez les performances, surveillez vos déploiements et visualisez vos coûts grâce à un dashboard interactif."
    },
    integration: {
      title: "Intégration Native avec les Clouds",
      description: "Connectez Azure, AWS ou GCP facilement, synchronisez vos ressources existantes via API sécurisée."
    }
  },
  footer: {
    copyright: "© {{year}} GenIaC. Tous droits réservés."
  }
};
